import { useState } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { SelectableTeamRow } from '../SelectableTeamRow';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function flattenTeams(teams, expandedIds, depth = 0) {
  return teams.flatMap(team => {
    const row = {
      team,
      depth
    };
    const shouldExpand = !expandedIds || expandedIds.has(team.id);
    if (shouldExpand && team.childTeams.length > 0) {
      return [row, ...flattenTeams(team.childTeams, expandedIds, depth + 1)];
    }
    return [row];
  });
}
function getInitialExpandedIds(teams) {
  const ids = new Set();
  function collect(ts) {
    ts.forEach(t => {
      if (t.childTeams.length > 0) {
        ids.add(t.id);
        collect(t.childTeams);
      }
    });
  }
  collect(teams);
  return ids;
}
export function SelectableTeamList({
  teams
}) {
  const [selectedTeamIds, setSelectedTeamIds] = useState(new Set());
  const [expandedTeamIds, setExpandedTeamIds] = useState(() => getInitialExpandedIds(teams));
  const allTeams = flattenTeams(teams);
  const visibleTeams = flattenTeams(teams, expandedTeamIds);
  const handleChange = (teamId, checked) => {
    setSelectedTeamIds(prev => {
      const next = new Set(prev);
      if (checked) {
        next.add(teamId);
      } else {
        next.delete(teamId);
      }
      return next;
    });
  };
  const handleToggleExpand = teamId => {
    setExpandedTeamIds(prev => {
      const next = new Set(prev);
      if (next.has(teamId)) {
        next.delete(teamId);
      } else {
        next.add(teamId);
      }
      return next;
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      marginBlockEnd: "400",
      marginBlockStart: "600",
      children: /*#__PURE__*/_jsxs(Text, {
        as: "h5",
        marginBlockEnd: "0",
        whiteSpace: "nowrap",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "app-governance-lib.installPermissions.options.specificTeams.teamsSelected",
          options: {
            selectedCount: selectedTeamIds.size,
            count: allTeams.length
          }
        }), allTeams.length > 0 && /*#__PURE__*/_jsx(Text, {
          as: "span",
          color: "text-core-subtle",
          marginInlineStart: "100",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app-governance-lib.installPermissions.options.specificTeams.teamsSelectedCount",
            options: {
              selectedCount: selectedTeamIds.size,
              count: allTeams.length
            }
          })
        })]
      })
    }), /*#__PURE__*/_jsx(View, {
      backgroundColor: "fill-surface-default",
      borderColor: "border-core-subtle",
      borderWidth: "100",
      borderStyle: "solid",
      borderRadius: "transitional-container",
      inlineSize: "100%",
      children: visibleTeams.map(({
        team,
        depth
      }, index) => /*#__PURE__*/_jsx(SelectableTeamRow, {
        isFirst: index === 0,
        teamName: team.name,
        depth: depth,
        checked: selectedTeamIds.has(team.id),
        onChange: checked => handleChange(team.id, checked),
        hasChildren: team.childTeams.length > 0,
        isExpanded: expandedTeamIds.has(team.id),
        onToggleExpand: () => handleToggleExpand(team.id)
      }, team.id))
    })]
  });
}